module.exports = __webpack_public_path__ + "vinay-419d2933c5c042e127c4.jpeg";